module.exports = __webpack_public_path__ + "media/images/checkmark_violet-71c2f195c4bec4d294f9fbef06f565f9.svg";